import { InjectionToken } from '@angular/core'
import { GamePlayConfig } from 'shared-services'

export const gamePlayConfigToken = new InjectionToken<GamePlayConfig>(
  'GamePlayConfigToken',
)
